// 位置发现管理
export const localDiscoveryManageRouter = [
  {
    path: '/service/local/discovery/list',
    name: 'DiscoveryManageList',
    component: () => import('@/views/service/serviceProvider/localDiscoveryManage/DiscoveryManageList'),
    meta: {
      title: '位置发现管理',
      keepAlive: false
    }
  },
  {
    path: '/service/local/discovery/addOrEdit',
    name: 'LocalDiscoveryAddOrEdit',
    component: () => import('@/views/service/serviceProvider/localDiscoveryManage/LocalDiscoveryAddOrEdit.vue'),
    meta: {
      title: '新建/编辑',
      keepAlive: false
    }
  }
]